import { render, staticRenderFns } from "./hangOrder.vue?vue&type=template&id=43dd5588&"
import script from "./hangOrder.vue?vue&type=script&lang=js&"
export * from "./hangOrder.vue?vue&type=script&lang=js&"
import style0 from "./hangOrder.vue?vue&type=style&index=0&id=43dd5588&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports